
<template>
    <el-dialog
        :visible="visible"
        :width="width"
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="!isSubmiting"
        :show-close="!isSubmiting"
        :destroy-on-close="true"
        custom-class="micro-confirmation-modal"
        @update:visible="$emit('update:visible', $event)"
        @closed="$emit('closed')"
    >
        <div
            class="px-4 d-flex flex-column justify-content-center align-items-center"
            v-loading="isLoading"
        >
            <!-- Ícone -->
            <slot name="icon">
                <el-tag
                    class="d-flex align-items-center justify-content-center rounded-circle"
                    :type="tagType"
                    :style="{ width: '64px', height: '64px' }"
                >
                    <i
                        :class="icon"
                        :style="{ fontSize: '32px' }"
                    ></i>
                </el-tag>
            </slot>

            <!-- Título / Descrição -->
            <div class="text-center my-2">
                <slot name="header">
                    <h4 class="font-weight-bold">
                        {{ title }}
                    </h4>

                    <h5 v-if="description" class="text-muted">
                        {{ description }}
                    </h5>
                </slot>
            </div>

            <!-- Actions -->
            <div class="d-flex align-items-center justify-content-center mt-3">
                <el-button
                    plain
                    :disabled="isLoading || isSubmiting"
                    @click="$emit('cancel')"
                >
                    {{ cancelText }}
                </el-button>

                <el-button
                    :type="confirmType"
                    :disabled="disabled || isLoading || isSubmiting"
                    @click="$emit('confirm')"
                >
                    {{ confirmText }}

                    <i
                        v-if="isSubmiting"
                        class="el-icon-loading"
                    ></i>

                    <i
                        v-else-if="icon"
                        :class="icon"
                    ></i>
                </el-button>
            </div>
        </div>

        <!-- Conteúdo extra -->
        <template v-if="$slots.default">
            <el-divider class="mt-3"></el-divider>
            <slot></slot>
        </template>
    </el-dialog>
</template>

<script>
    import {
        Loading,
        Button,
        Dialog,
        Divider,
        Tag,
    } from 'element-ui';

    export default {
        name: 'ConfirmationModal',

        props: {
            visible: {
                type: Boolean,
                default: false,
            },

            isLoading: {
                type: Boolean,
                default: false,
            },

            isSubmiting: {
                type: Boolean,
                default: false,
            },

            disabled: {
                type: Boolean,
                default: false,
            },

            title: {
                type: String,
                default: 'Confirmar ação',
            },

            description: {
                type: String,
                default: 'Deseja realmente prosseguir com esta ação?',
            },

            confirmText: {
                type: String,
                default: 'Confirmar',
            },

            cancelText: {
                type: String,
                default: 'Cancelar',
            },

            icon: {
                type: String,
                default: 'el-icon-check',
            },

            confirmType: {
                type: String,
                default: 'primary',
            },

            tagType: {
                type: String,
                default: 'primary',
            },

            width: {
                type: String,
                default: '650px',
            },
        },

        directives: {
            loading: Loading.directive,
        },

        components: {
            [Button.name]: Button,
            [Dialog.name]: Dialog,
            [Divider.name]: Divider,
            [Tag.name]: Tag,
        },
    };
</script>

<style>
    .micro-confirmation-modal {
        border-radius: 20px;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/_micro/modals/ConfirmationModal.vue